// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandCoinsBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.095 17.235a3.55 3.55 0 0 0-3.079-.61L21.5 17.657V17.5a4 4 0 0 0-4-4h-6.258a4.471 4.471 0 0 0-3.18 1.318L5.374 17.5H2.5A2.5 2.5 0 0 0 0 20v5a2.5 2.5 0 0 0 2.5 2.5H15c.123 0 .245-.015.364-.045l8-2c.076-.019.151-.044.223-.075l4.853-2.067a1 1 0 0 0 .084-.038 3.577 3.577 0 0 0 .571-6.04ZM3 20.5h1.5v4H3v-4Zm24.21.076-4.689 2-7.706 1.924H7.5v-4.875l2.682-2.683a1.49 1.49 0 0 1 1.06-.442H17.5a1 1 0 0 1 0 2H14a1.5 1.5 0 1 0 0 3h4c.113 0 .226-.013.336-.038l8.375-1.926.059-.015a.576.576 0 0 1 .44 1.055ZM20.5 12.5c.137 0 .275-.008.41-.019a5 5 0 1 0 4.183-6.963A5 5 0 1 0 20.5 12.5Zm7-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-7-5a2 2 0 0 1 1.813 1.151A5 5 0 0 0 20.6 9.5H20.5a2 2 0 0 1 0-4Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
